import React from 'react';

const BetaBanner: React.FC = () => {
  return (
    <div className="fixed top-3 left-3 z-[9999] pointer-events-none">
      <div className="inline-flex items-center space-x-2 rounded-md bg-yellow-200/95 px-3 py-1 shadow-lg ring-1 ring-yellow-300 text-yellow-900">
        <span className="text-[10px] font-extrabold uppercase tracking-wider bg-yellow-300 text-yellow-900 px-2 py-0.5 rounded">
          Beta
        </span>
        <span className="text-xs font-medium">
          Données les plus récentes: 2022
        </span>
      </div>
    </div>
  );
};

export default BetaBanner;


